import Eventemitter3 from 'eventemitter3';
import { AppInfo, BASE_URL } from './constant';

import { EthereumProvider } from './provider/EthereumProvider/EthereumProvider';
import SolanaProvider from './provider/SolanaProvider/SolanaProvider';
import { TonProvider } from './provider/TonProvider/TonProvider';
import SuiProvider from './provider/SuiProvider/SuiProvider';
import { TomoOptions } from './types/types';

class WalletTgSdk extends Eventemitter3 {
  version = AppInfo.version;
  ethereum: EthereumProvider;
  solana: SolanaProvider;
  tomo_ton: TonProvider;
  tomo_sui: SuiProvider;
  connectUrl: string;
  bridgeUrl: string;
  connect_direct_link: string;
  injected: boolean;
  metaData
  getAppInfo = () => {
    return {
      ...AppInfo,
    };
  };
  constructor(options?: TomoOptions) {
    super();

    const metaData = options?.metaData;
    this.connectUrl = options?.connect || BASE_URL.connect;
    this.bridgeUrl = options?.bridge || BASE_URL.bridge;
    this.connect_direct_link =
      options?.connect_direct_link || BASE_URL.connect_direct_link;
    this.injected = options?.injected || false;
    this.metaData = {
      icon: metaData?.icon,
      name: metaData?.name,
      url: metaData?.url,
      direct_link: metaData?.direct_link,
      description: metaData?.description,
    };
    this._initialize();
  }
  _initialize() {
    //initialize provider
    this.ethereum = new EthereumProvider({
      connect: this.connectUrl,
      bridge: this.bridgeUrl,
      connect_direct_link: this.connect_direct_link,
      metaData: this.metaData,
    });
    this.solana = new SolanaProvider({
      connect: this.connectUrl,
      bridge: this.bridgeUrl,
      connect_direct_link: this.connect_direct_link,
      metaData: this.metaData,
    });
    this.tomo_ton = new TonProvider({
      connect: this.connectUrl,
      bridge: this.bridgeUrl,
      connect_direct_link: this.connect_direct_link,
      metaData: this.metaData,
    });
    this.tomo_sui = new SuiProvider({
      connect: this.connectUrl,
      bridge: this.bridgeUrl,
      connect_direct_link: this.connect_direct_link,
      metaData: this.metaData,
    });
    // this.bitcoin = new BitcoinProvider({
    //   connect: this.connectUrl,
    //   bridge: this.bridgeUrl,
    //   connect_direct_link: this.connect_direct_link,
    //   metaData: this.metaData,
    // });
    if (this.injected) {
      if (!window.ethereum) {
        window.ethereum = this.ethereum;
        // window.tg_tomo_btc = this.bitcoin;
        dispatchEvent(new Event('ethereum#initialized'));
      }
      if (!window.tomo_sol) {
        window.tomo_sol = this.solana;
        dispatchEvent(new Event('tomo_sol#initialized'));
      }
      if (!window.tomo_ton) {
        window.tomo_ton = this.tomo_ton;
        dispatchEvent(new Event('tomo_ton#initialized'));
      }
      if (!window.tomo_sui) {
        window.tomo_sui = this.tomo_sui;
        dispatchEvent(new Event('tomo_sui#initialized'));
      }
    }
    this.emit('_initialized');
  }
}

export default WalletTgSdk;
